import { render, staticRenderFns } from "./modalCodigoVerificacionLogin.vue?vue&type=template&id=006be065&scoped=true"
import script from "./modalCodigoVerificacionLogin.vue?vue&type=script&lang=js"
export * from "./modalCodigoVerificacionLogin.vue?vue&type=script&lang=js"
import style0 from "./modalCodigoVerificacionLogin.vue?vue&type=style&index=0&id=006be065&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006be065",
  null
  
)

export default component.exports